import { Providers } from './app/providers.js';
import { AppRouter } from './app/router.js';

export function App(): JSX.Element {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
